<template>
  <LoadingSpinner :loading="isLoading" />
  <div class="container py-5 justify-content-center">
    <div class="d-flex justify-content-center mb-5">
      <img src="https://res.cloudinary.com/dndu5hvcf/image/upload/v1691000905/Group_1425_0ac53a6804.png?updated_at=2023-08-02T18:28:25.447Z"/>
    </div>
    
    <div class="row justify-content-center" v-if="order && order.attributes">
      <div class="col-md-8 col-11" v-if="testimonials.length == 0">
        <div class="row mb-5">
          <div class="col-12 heading">
            <strong class="h3">Olá, <span class="text-uppercase">{{ order.attributes.client_name }}</span></strong>
            <p class="h5 my-2" style="font-weight:normal;">Avalie cuidadosamente os itens adquiridos, pois dessa forma poderei melhorar nossos produtos e recrutar ainda mais novos agentes (felinos ou não) para concluir minha missão de dominação mundial.</p>
          </div>
        </div>
        <div class="row mb-5 pb-5 product_item" v-for="item in items" :key="item.id"
        :class="item.erroStatus ? 'err' : ''"        
        >
          <div class="col-md-4 col-12">          
            <div class="box-image">
              <img class="w-100" v-if="item.apiData && item.apiData.images" :src="'https://cdn.awsli.com.br/500x500/' + item.apiData.images[0].caminho"/>             
            </div>
          </div>
          <div class="col-md-7 offset-md-1 col-12">
            <div class="mb-3">
              <p>O que achou do produto<br><strong class="h4">{{ item.nome }}?</strong></p>
            </div>
            <div class="rating mb-4">
              <button class="rating_btn" v-for="rating in ratings" :key="rating"
              @click="setRating(item.id,rating)">
                
                <i :class="
                  {
                    'fa fa-star': rating <= (item.rating || 0),
                    'fa fa-star-o': rating > (item.rating || 0)
                  }
                "></i>
              </button>
              <span>{{ reactions[(item.rating || 0)] }}</span>
            </div>
            <div class="mb-4">
              <label class="form-label"><i class="fa fa-comment-o me-1"></i>Gostaria de adicionar alguma observação?</label>
              <textarea name="content" class="form-control" v-model="item.content"></textarea>
            </div>
            <div>
              <label for="formFile" class="form-label"><i class="fa fa-file-image-o me-1"></i> Tirou fotos bacanas dele? Manda pra gente!</label>
              <input class="form-control" type="file" id="formFile" multiple accept="image/*" @change="handleFileChange(item.id, $event)" >
            </div>
          </div>
        </div>
        <div class="row store_item mb-4">
          <div class="col-12">
            <div class="mb-3">
              <p class="h4">Avaliação da Compra</p>
            </div>
            <div class="rating mb-4">
              <button class="rating_btn" v-for="rating in ratings" :key="rating"
              @click="setRatingStore(rating)">
                
                <i :class="
                  {
                    'fa fa-star': rating <= (store.rating || 0),
                    'fa fa-star-o': rating > (store.rating || 0)
                  }
                "></i>
              </button>
              <span>{{ reactions[(store.rating || 0)] }}</span>
            </div>  
            <div>
              <label class="form-label"><i class="fa fa-comment-o me-1"></i>Me conta como foi comprar na minha loja, humano.</label>
              <textarea name="content" class="form-control" v-model="store.content"></textarea>
            </div>          
          </div>
        </div>
        <div class="row" v-for="item in errForm" :key="item.id">
          <div class="col-12">
            <div class="alert alert-warning" role="alert" v-html="item">
              
            </div>
          </div>
        </div>
        <div class="row mt-5 pt-3 pb-5 mb-5 justify-content-center align-items-center">
          <div class="col-md-6">
            <button class="btn btn-big" type="button" @click="makeTestimonial()">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Deixar meu depoimento
            </button>
          </div>
        </div>
      </div>
      <div v-else
      class="col-md-4 col-12">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <strong class="h3">Olá, <span class="text-uppercase">{{ order.attributes.client_name }}</span></strong>
            
            <p class="h5 my-4 mt-5" style="font-weight:normal;"><b>Suas avaliações foram recebidas.</b><br>Muito obrigado por contribuir com a melhoria de nossos produtos e serviços.</p>
            <a class="btn btn-big mt-5" style="width:fit-content" href="https://www.canseidesergato.com">Ir para a loja</a>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<style scoped>
.btn.btn-big i{margin-top:4px}
.btn.btn-big{
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem 2rem;
  background: var(--black);
  color:#fff;
  text-transform: uppercase;

}
.box-image{border:1px solid #d9d9d9;border-radius:10px;overflow:hidden}
.product_item{border-bottom: 1px solid #d9d9d9;}
  .fa.fa-star,
  .fa.fa-star-o{
    color: var(--green);
  }
  .rating{
    display:flex;
    gap:5px;
    align-items: center;
  }
  .rating span{
    font-weight: bold;
    font-size: 12px;
    margin-left: .5rem;
    color: var(--black);
    background:var(--violet);
    border-radius:10px;
    padding:3px 10px
  }
  .rating_btn{
    padding: 0;
    border: 0;
    background: transparent;
    font-size:24px;
  }

  @media(max-width:990px){
    img{max-width:100%}

    .btn.btn-big{font-size: 20px;
      padding: .5rem 1rem;
      gap: .7rem;}

      .heading{text-align: center;}
      .heading p{font-size: 18px;line-height: initial;}

      .box-image{height: 200px;margin-bottom: 1rem;}
      .box-image img{max-height: 100%;max-width: 100%;height: fit-content;        width: fit-content !important;
        margin: 0 auto !important;
        display: block;
}
  }
</style>

<script>
import axios from 'axios';
// URL da API que você deseja acessar
 const apiUrl = 'https://cms-cdsg.up.railway.app/api/';
//const apiUrl = 'http://localhost:1337/api/'

// Configuração do cabeçalho de autorização
const config = {
  headers: {
    //Authorization: `Bearer ${token}`,
  },
};
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  components: {
    LoadingSpinner
  },
  name: 'MakeTestimonial', 
  props:["id"],
  data() {
    return {
      order:{},
      items: [],
      hash:null,
      ratings:[1,2,3,4,5],
      reactions:["Selecione...","Péssimo","Ruim", "Bom", "Ótimo", "Excelente"],
      store:{
        rating:0,
        content:""
      },
      errForm : [],
      testimonials : [],
      isLoading:true,
    };
  },
  async mounted() {
    await this.fetchItemsFromApi(); // Aguarde a conclusão da solicitação
  },
  created(){
    this.hash = this.$route.query.hash;
    console.log(this.hash)
  },  
  methods: {
    setRating(id_, rating_){
      let itemToUpdate = this.items.find(el => el.id == id_)
      if(itemToUpdate){
        itemToUpdate.rating = rating_
      }
      //this.manageTestimonial('product',id_,rating_)
    },
    setRatingStore(rating_){
      this.store.rating = rating_
      
    },
    async makeTestimonial(){
      this.isLoading = true
      this.errForm = [];
     // let err = this.items.filter(el => !el.rating || !el.content)
      // for (const item of err) {
      //   this.errForm.push(`Preencha a avaliação do produto <b>${item.nome}</b>`)
      //   this.items.find(el => el.id == item.id).erroStatus = true
      // } 
      // if(this.store.rating == 0 && this.store.content == ''){
      //   this.errForm.push('Preencha a avaliação da sua compra')
      // }
      
      if(this.store.rating != 0 ){
        for (const item of this.items) {
            const data = {
              data:{
                type:'product',
                order:[this.order.id],
                content:item.content || null,
                rating:item.rating,
                product_sku:item.sku,
                gallery: item.uploaded_files && item.uploaded_files.map(item => item.id) || null
              }
            }
            this.generateTestimonial(data)            
        } 
        //if(this.store.rating != 0 && this.store.content != ''){
          this.generateTestimonial({
            data:{
              type:'store',
              order:[this.order.id],
              content:this.store.content || null,
              rating: this.store.rating
            }
          })            
        //}
      }
      if(this.testimonials.length > 0){
        alert('Muito obrigado por dar sua avaliação!');
      }
      this.isLoading = false
    },
    handleFileChange(id_, event) {
      let itemToUpdate = this.items.find(el => el.id == id_)
      if(itemToUpdate){
        itemToUpdate.files = event.target.files;
      }    
      this.uploadFile(id_,itemToUpdate)
    },
    async uploadFile(id_, item){
      try {
        const formData = new FormData()
        for (let i = 0; i < item.files.length; i++) {
          formData.append('files', item.files[i]);
        }
        const response = await axios.post(apiUrl + `upload/`, formData , {
          ...config,
          'Content-Type': 'multipart/form-data',
        });        
        
        console.log(response.data)
        let itemToUpdate = this.items.find(el => el.id == id_)
        if(itemToUpdate){
          itemToUpdate.uploaded_files = response.data
        }    
      } catch (error) {
        console.error('Erro ao buscar itens:', error);
      }
    },
    async generateTestimonial(data){     
      console.log(data) 
      try {
        const response = await axios.post(apiUrl + `testimonials`, data, config);

        console.log(response)
        this.testimonials.push(response.data.data)
      } catch (error) {
        console.error('Erro ao buscar itens:', error);
      }
    },
    async fetchProductInfo(id_){
      const response = await axios.get(apiUrl + `webhooks/produto-loja-integrada?sku=${id_}`, config);
          console.log(response.data)
         
      return response.data
      // const response = await axios.get(`https://api.awsli.com.br/v3/products/${id_}`, {
      //   headers: {
      //     "x-store-id": `31979`,
      //   },
      // });
      // return response.data.data
      //console.log(response)
    },
    async fetchItemsFromApi() {
      try {
               const response = await axios.get(apiUrl + `orders/?filters[$or][0][testimonial_key][$eq]=${this.id}&filters[$or][1][order_id][$eq]=${this.id}&populate=deep`, config);
        let responseData = response.data.data[0]
        for (const item of responseData.attributes.products) {
          console.log(responseData.attributes.products)
          item.apiData = await this.fetchProductInfo(item.sku);
        }

        this.items = [...responseData.attributes.products];
        this.testimonials = responseData.attributes.testimonials && responseData.attributes.testimonials.data ? [...responseData.attributes.testimonials.data] : [];
        // console.log(this.testimonials)
        this.order = responseData;
        // console.log('order',this.order)
        // console.log(this.items)
        if(this.testimonials.length > 0){
          for(const item of this.testimonials){
            //console.log('test',item)
            let q = this.items.find(el => el.sku == item.attributes.product_sku)
            if(q){
              q.rating = item.attributes.rating
              q.content = item.attributes.content
            }
          }
        }
      } catch (error) {
        console.error('Erro ao buscar itens:', error);
      }

      this.isLoading = false
    },
  },
};
</script>






